/**
 * This is a look-up table of all of the props that `react-datepicker` supports.
 * It is used as a way to separate field props from `react-datepicker` input
 * props.
 */
export default Object.freeze({
    adjustDateOnChange:          true,
    allowSameDay:                true,
    ariaLabelledBy:              true,
    autoComplete:                true,
    autoFocus:                   true,
    calendarClassName:           true,
    calendarContainer:           true,
    children:                    true,
    className:                   true,
    customInput:                 true,
    customInputRef:              true,
    dateFormat:                  true,
    dateFormatCalendar:          true,
    dayClassName:                true,
    disabled:                    true,
    disabledKeyboardNavigation:  true,
    disableUnderline:            true,
    dropdownMode:                true,
    endDate:                     true,
    excludeDates:                true,
    filterDate:                  true,
    fixedHeight:                 true,
    formatWeekNumber:            true,
    highlightDates:              true,
    id:                          true,
    includeDates:                true,
    includeTimes:                true,
    injectTimes:                 true,
    inline:                      true,
    isClearable:                 true,
    locale:                      true,
    maxDate:                     true,
    minDate:                     true,
    monthsShown:                 true,
    name:                        true,
    onBlur:                      true,
    onChange:                    true,
    onSelect:                    true,
    onWeekSelect:                true,
    onClickOutside:              true,
    onChangeRaw:                 true,
    onFocus:                     true,
    onInputClick:                true,
    onKeyDown:                   true,
    onMonthChange:               true,
    onYearChange:                true,
    onInputError:                true,
    open:                        true,
    onCalendarOpen:              true,
    onCalendarClose:             true,
    openToDate:                  true,
    peekNextMonth:               true,
    placeholderText:             true,
    popperContainer:             true,
    popperClassName:             true,
    popperModifiers:             true,
    popperPlacement:             true,
    popperProps:                 true,
    preventOpenOnFocus:          true,
    readOnly:                    true,
    required:                    true,
    scrollableYearDropdown:      true,
    scrollableMonthYearDropdown: true,
    selected:                    true,
    selectsEnd:                  true,
    selectsStart:                true,
    showMonthDropdown:           true,
    showPreviousMonths:          true,
    showMonthYearDropdown:       true,
    showWeekNumbers:             true,
    showYearDropdown:            true,
    strictParsing:               true,
    forceShowMonthNavigation:    true,
    showDisabledMonthNavigation: true,
    startDate:                   true,
    startOpen:                   true,
    tabIndex:                    true,
    timeCaption:                 true,
    title:                       true,
    todayButton:                 true,
    useWeekdaysShort:            true,
    formatWeekDay:               true,
    value:                       true,
    weekLabel:                   true,
    withPortal:                  true,
    yearDropdownItemNumber:      true,
    shouldCloseOnSelect:         true,
    showTimeInput:               true,
    showMonthYearPicker:         true,
    showQuarterYearPicker:       true,
    showTimeSelect:              true,
    showTimeSelectOnly:          true,
    timeFormat:                  true,
    timeIntervals:               true,
    minTime:                     true,
    maxTime:                     true,
    excludeTimes:                true,
    useShortMonthInDropdown:     true,
    clearButtonTitle:            true,
    previousMonthButtonLabel:    true,
    nextMonthButtonLabel:        true,
    previousYearButtonLabel:     true,
    nextYearButtonLabel:         true,
    timeInputLabel:              true,
    renderCustomHeader:          true,
    renderDayContents:           true,
    wrapperClassName:            true,
    inlineFocusSelectedMonth:    true,
    onDayMouseEnter:             true,
    onMonthMouseLeave:           true,
    showPopperArrow:             true
});
